<template>
  <d-modal
    :active="isActive"
    :width="600"
    @close="handleClose"
    :can-cancel="['escape', 'x', 'outside']"
  >
    <div class="p-6">
      <!-- Header -->
      <div class="mb-6">
        <h3 class="text-2xl font-bold">
          Duplicate Subject Area
        </h3>
        <p>
          Create a copy of "{{ subjectArea?.name }}"
        </p>
      </div>

      <!-- Form -->
      <form @submit.prevent="handleSubmit" class="space-y-4">
        <!-- Name Field -->
        <d-field label="New Name *">
          <d-input 
            v-model="form.name" 
            :required="true"
            placeholder="Enter new subject area name"
          />
        </d-field>


        <!-- Loading State -->
        <div v-if="loading" class="flex justify-center py-4">
          <span class="loading loading-spinner loading-md"></span>
        </div>

        <!-- Form Actions -->
        <div class="flex justify-end gap-3 pt-4">
          <d-btn 
            type="button"
            flat 
            @click="handleClose"
          >
            Cancel
          </d-btn>
          <d-btn 
            type="submit"
            color="primary"
            :disabled="!isFormValid || loading"
          >
            Duplicate Subject Area
          </d-btn>
        </div>
      </form>
    </div>
  </d-modal>
</template>

<script>
import axios from 'axios';
import { toast } from '@services/toast.service';

export default {
  name: 'DuplicateSubjectAreaModal',
  
  props: {
    active: {
      type: Boolean,
      default: false
    },
    subjectArea: {
      type: Object,
      default: null
    }
  },

  data() {
    return {
      loading: false,
      form: {
        name: '',
      }
    };
  },

  computed: {
    isActive() {
      return this.active;
    },
    
    isFormValid() {
      return this.form.name;
    }
  },

  watch: {
    active(newVal) {
      if (newVal) {
        this.resetForm();
        if (this.subjectArea) {
          this.populateForm();
        }
      }
    }
  },

  methods: {
    resetForm() {
      this.form = {
        name: '',
      };
    },

    populateForm() {
      if (this.subjectArea) {
        this.form.name = `Copy of ${this.subjectArea.name}`;
      }
    },

    async handleSubmit() {
      if (!this.isFormValid || !this.subjectArea) return;

      this.loading = true;
      try {
        await axios.post(`/api/subject-areas/${this.subjectArea.id}/duplicate?newName=${this.form.name}`);
        toast.success('Subject area duplication initiated. You will receive an email when completed.');
        this.$emit('saved');
      } catch (error) {
        console.error('Error duplicating subject area:', error);
        toast.error('Failed to duplicate subject area');
      } finally {
        this.loading = false;
      }
    },

    handleClose() {
      this.$emit('close');
    }
  }
};
</script>

<style scoped>
/* Removed duplicate modal styling to fix ghost outline issue */
</style>
